import { render } from "./info-box.vue?vue&type=template&id=31bf1e14&scoped=true&ts=true"
import script from "./info-box.vue?vue&type=script&lang=ts"
export * from "./info-box.vue?vue&type=script&lang=ts"

import "./info-box.vue?vue&type=style&index=0&id=31bf1e14&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31bf1e14"]])

export default __exports__